import { BellOutlined, ExclamationCircleFilled } from '@ant-design/icons'
import {
  GraviButton,
  Horizontal,
  NothingMessage,
  Texto,
  Vertical,
} from '@gravitate-js/excalibrr'
import { Drawer, List } from 'antd'

export type NotificationItem = {
  id: string
  type?: 'error' | 'warning' | 'info' | string
  title?: string
  message?: string
  timestamp?: string
}

interface ControlPanelProps {
  visible: boolean
  onClose: () => void
  notifications: NotificationItem[]
  setNotifications: (notifications: NotificationItem[]) => void
}

export function NotificationDrawer({
  onClose,
  visible,
  notifications,
  setNotifications,
}: ControlPanelProps) {
  const handleClearAll = () => {
    setNotifications([])
  }

  const handleDismiss = (id: string) => {
    setNotifications(notifications.filter((n) => n.id !== id))
  }

  return (
    <Drawer
      title='Notifications'
      placement='right'
      width={450}
      onClose={onClose}
      open={visible}
    >
      <Vertical gap={8} style={{ overflow: 'visible' }}>
        {notifications.length > 0 && (
          <Horizontal alignItems='center' justifyContent='flex-end'>
            <GraviButton
              size='small'
              type='link'
              onClick={handleClearAll}
              buttonText='Clear All'
            />
          </Horizontal>
        )}

        <div style={{ maxHeight: '100%', overflow: 'auto' }}>
          {notifications.length === 0 ? (
            <NothingMessage
              icon={<BellOutlined style={{ fontSize: 48 }} />}
              title='No Notifications'
              message='You have no new notifications.'
            />
          ) : (
            <List
              dataSource={notifications}
              renderItem={(item: NotificationItem) => (
                <List.Item
                  key={item.id}
                  actions={[
                    <GraviButton
                      key='dismiss'
                      size='small'
                      type='link'
                      onClick={() => handleDismiss(item.id)}
                      buttonText='Dismiss'
                    />,
                  ]}
                >
                  <List.Item.Meta
                    avatar={
                      <ExclamationCircleFilled
                        style={{
                          fontSize: 20,
                          color: item.type === 'error' ? '#ff4d4f' : '#faad14',
                        }}
                      />
                    }
                    title={item.title}
                    description={
                      <Vertical
                        gap={4}
                        style={{ flex: '0', overflow: 'visible' }}
                      >
                        <span>{item.message}</span>
                        <Texto category='label' appearance='secondary'>
                          {item.timestamp || new Date().toLocaleString()}
                        </Texto>
                      </Vertical>
                    }
                  />
                </List.Item>
              )}
            />
          )}
        </div>
      </Vertical>
    </Drawer>
  )
}
